import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { WarmedatenPermissionService } from '@app/warmedaten/services/warmedaten-permission.service';
import { BasicFeaturesActivationTabComponent } from './components/features-activation-tab/basic-features-activation-tab/basic-features-activation-tab.component';
import { ExterneAppsActivationTabComponent } from './components/features-activation-tab/externe-apps-activation-tab/externe-apps-activation-tab.component';
import { FeaturesActivationTabComponent } from './components/features-activation-tab/features-activation-tab.component';
import { PremiumFeaturesActivationTabComponent } from './components/features-activation-tab/premium-features-activation-tab/premium-features-activation-tab.component';
import { MunicipalityInformationTabComponent } from './components/municipality-information-tab/municipality-information-tab.component';
import { MunicipalityManagementComponent } from './municipality-management.component';
import { MunicipalityManagementApiService } from './services/municipality-management-api.service';
import { ExterneAppFeatureService } from './services/externe-app-feature.service';

import { SafePipe } from './shared/pipes/safe.pipe';
import { ExterneIndividualLinkComponent } from './components/externe-individual-link/externe-individual-link.component';
import { DamageReportTabComponent } from './components/damage-report-tab/damage-report-tab.component';

@NgModule({
  declarations: [
    MunicipalityManagementComponent,
    MunicipalityInformationTabComponent,
    DamageReportTabComponent,
    FeaturesActivationTabComponent,
    PremiumFeaturesActivationTabComponent,
    BasicFeaturesActivationTabComponent,
    ExterneAppsActivationTabComponent,
    SafePipe,
    ExterneIndividualLinkComponent,
  ],
  imports: [CommonModule, SharedModule],
  providers: [WarmedatenPermissionService, MunicipalityManagementApiService, ExterneAppFeatureService],
})
export class MunicipalityManagementModule {}
